export module numberext {

}
declare global {
    interface NumberConstructor {
        /**
         * Formats a number into a thousands seperated string.
         * @param number The number to parse
         */
        parseNumerToLocaleFormattedString(string: string, locals?: string | string[]): string;

        toLocaleFormattedString(number: Number, locals?: string | string[]): string;

        thousandSeperator(value: string, local: string): string;

        isNumeric(string: string): boolean;
    }

    interface Number {
        /**
         * Formats a number into a thousands seperated string.
         * @param number The number to parse
         */
        toLocaleFormattedString(locals?: string | string[]): string;
    }
}

Number.parseNumerToLocaleFormattedString = function (string: string, locals?: string | string[]): string {
    if (Number.isNumeric(string)) {
        return Number.toLocaleFormattedString(Number(string));
    } else {
        return NaN.toString();
    }
};

Number.toLocaleFormattedString = function (number: Number, locals?: string | string[]): string {
    if (Number.prototype.toLocaleString) {
        return number.toLocaleString(locals);
    } else {
        var singleLocal: string = (locals && locals instanceof Array) ? locals[0] : <string>locals;
        return Number.thousandSeperator(number + "", singleLocal);
    }
};

Number.thousandSeperator = function (value: string, local: string): string {
        let separator: string;
        let decimalsSeparator: string;
        switch (local) {
            case "en-GB":
            case "en-US":
            case "en-CA":
                separator = ",";
                decimalsSeparator = ".";
            break;
            default: // "nl-NL", "de-DE"
                separator = ".";
                decimalsSeparator = ",";
            break;
        }
        let num: string = (this + "");

        // test for and get any decimals (the later operations won't support them)
        let decimals: string = "";
        if (/\./.test(num)) {
            // this regex grabs the decimal point as well as the decimal numbers
            decimals = num.replace(/^.*(\..*)$/, "$1");
        }

        num = num.replace(decimals, "")
            .split("").reverse().join("")
            .match(/[0-9]{1,3}-?/g).join(separator)
            .split("").reverse().join("");

        return `${num}${decimalsSeparator}${decimals}`;
};

Number.isNumeric = function (string: string): boolean {
    return !isNaN(+string);
    /* return (string !== string + 1) // infinity check
        && (coercion === +string) // cute coercion check
        && (typeof string !== "object"); // array/object check */
};

Number.prototype.toLocaleFormattedString = function (this: Number, locals?: string | string[]): string {
    return Number.toLocaleFormattedString(this, locals);
};

export module Number {}